import React, { FC } from 'react';
import { LogoContainer } from '@marriott/mi-ui-library';
import { BrandLogoProps } from './BrandLogo.types';
import { StyledBrandLogo } from './BrandLogo.styles';
import { useDttStore } from '../../../store';

export const BrandLogo: FC<BrandLogoProps> = ({
  brandCode,
  customClass,
  ariaLabel,
  width,
  height,
  alignment,
  color,
  backgroundColor,
  variation = 'small',
  tabIndex = -1,
  aspectRatio = '3:2',
}) => {
  const { featureFlagLogo } = useDttStore();

  return (
    <div>
      {featureFlagLogo ? (
        brandCode && <LogoContainer
          brand={brandCode}
          width={width}
          height={height}
          aspectRatio={aspectRatio}
          alignment={alignment}
          color={color}
          backgroundColor={backgroundColor}
          isLink={false}
          ariaRole="img"
        />
      ) : (
        <StyledBrandLogo
          role="img"
          className={`brand-logo-${variation} brand-logo-${brandCode} ${customClass || 'brand-logo-default'}`}
          aria-label={ariaLabel}
          tabIndex={tabIndex}
        />
      )}
    </div>
  );
};
